import { questionnaireSectionApi } from '@/lib/api/questionnaireApi';
import { handleQueryError } from '@/lib/queryErrorHandler';
import { SectionFormData } from '@/lib/sectionSchema';
import { router } from '@inertiajs/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export function useCreateSectionMutation({
  templateId,
  onClose,
}: {
  templateId: number;
  onClose: () => void;
}) {
  const queryClient = useQueryClient();
  const createSectionMutation = useMutation({
    mutationFn: (data: SectionFormData) =>
      questionnaireSectionApi.create(templateId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['template', templateId],
      });
      toast.success('Section created successfully');
      onClose();
      router.reload({ only: ['template'] });
    },
    onError: (error) => handleQueryError(error),
  });

  const handleSubmit = (data: SectionFormData) => {
    createSectionMutation.mutate(data);
  };

  return {
    createSectionMutation,
    handleSubmit,
  };
}
